module.exports = __webpack_public_path__ + "static/img/411.640.729.d9e0add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/411.640.729.jpg
// module id = 209
// module chunks = 1